export type {
  UppyFile,
  UppyProgress,
  UppyResponse,
  UppyUploadEventData,
  UppyCompleteEventResult,
  UppyError,
  UppyEventMap,
  UppyS3UploadParams,
  TMeta,
  TBody,
} from 'bundles/fileuploader-uppy/types/UppyFileUploader';

export { default as UppyFileUploader } from 'bundles/fileuploader-uppy/components/UppyFileUploader';
